/**
 * 雪屏模块 - 全屏 SVG fractalNoise 滤镜
 * 内部雪点随机抖动，画面本身不动
 */

const SVG_NS = "http://www.w3.org/2000/svg";

export interface SnowOptions {
  /** 不透明度 0-1，默认 0.35 */
  opacity?: number;
  /** 基础频率，默认 0.95 */
  baseFrequency?: number;
  /** 抖动速度（秒），默认 0.4 */
  speed?: number;
}

export function createSnow(container: HTMLElement, options: SnowOptions = {}): () => void {
  const opacity = options.opacity ?? 0.35;
  const baseFrequency = options.baseFrequency ?? 0.95;
  const speed = options.speed ?? 0.4;

  const wrap = document.createElement("div");
  wrap.className = "snow";
  wrap.style.cssText = "position:absolute;inset:0;pointer-events:none;z-index:1;";

  const svg = document.createElementNS(SVG_NS, "svg");
  svg.setAttribute("xmlns", SVG_NS);
  svg.style.cssText = "width:100%;height:100%;display:block;";

  const filterId = `snowFilter-${Math.random().toString(36).slice(2, 8)}`;

  svg.innerHTML = `
    <defs>
      <filter id="${filterId}">
        <feTurbulence type="fractalNoise" baseFrequency="${baseFrequency}" numOctaves="2" seed="1" stitchTiles="stitch">
          <animate attributeName="seed" values="1;3;7;11;17;23;31;1" dur="${speed}s" repeatCount="indefinite"/>
        </feTurbulence>
        <feColorMatrix values="0 0 0 0 0.7
                               0 0 0 0 0.7
                               0 0 0 0 0.78
                               0 0 0 ${opacity} 0"/>
      </filter>
    </defs>
    <rect width="100%" height="100%" filter="url(#${filterId})"/>
  `;

  wrap.appendChild(svg);
  container.appendChild(wrap);

  return () => {
    wrap.remove();
  };
}

/**
 * 创建"密集版"雪屏（屏幕 1 用） - 用双层叠加增加密度感
 */
export function createDenseSnow(container: HTMLElement): () => void {
  const wrap = document.createElement("div");
  wrap.className = "snow dense";
  wrap.style.cssText = "position:absolute;inset:0;pointer-events:none;z-index:1;";

  const filterId = `denseSnowFilter-${Math.random().toString(36).slice(2, 8)}`;

  wrap.innerHTML = `
    <svg xmlns="${SVG_NS}" style="width:100%;height:100%;display:block;">
      <defs>
        <filter id="${filterId}">
          <feTurbulence type="fractalNoise" baseFrequency="1.3" numOctaves="3" seed="5" stitchTiles="stitch">
            <animate attributeName="seed" values="5;11;17;23;29;37;5" dur="0.15s" repeatCount="indefinite"/>
          </feTurbulence>
          <feColorMatrix values="0 0 0 0 0.85
                                 0 0 0 0 0.85
                                 0 0 0 0 0.9
                                 0 0 0 0.6 0"/>
        </filter>
      </defs>
      <rect width="100%" height="100%" filter="url(#${filterId})"/>
    </svg>
  `;

  container.appendChild(wrap);

  return () => wrap.remove();
}
